import { render, staticRenderFns } from "./DistributionChannelList.vue?vue&type=template&id=a7293510&scoped=true&lang=html"
import script from "./DistributionChannelList.vue?vue&type=script&lang=js"
export * from "./DistributionChannelList.vue?vue&type=script&lang=js"
import style0 from "./DistributionChannelList.vue?vue&type=style&index=0&id=a7293510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7293510",
  null
  
)

export default component.exports